import { render, staticRenderFns } from "./NewAlbum.vue?vue&type=template&id=7bdf4431&"
import script from "./NewAlbum.vue?vue&type=script&lang=js&"
export * from "./NewAlbum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports